import type { HTMLAttributes } from 'react';
import { memo } from 'react';
import styled, { css, useTheme } from 'styled-components';
import type { ITheme } from '../../../utils/theme';
import { getIconColor } from '../../input/helper-functions/colors';

export const SelectArrowDown = ({
  disabled = false,
  isOpen = false,
  hasError = false,
  ...props
}: {
  disabled: boolean;
  isOpen?: boolean;
  hasError?: boolean;
} & HTMLAttributes<HTMLSpanElement>) => {
  const theme = useTheme();
  return (
    <ArrowDownSpan aria-hidden="true" {...props} $isOpen={isOpen}>
      <svg
        display="block"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.0718 16.2418L12.0726 16.2426L17.0312 11.284L15.617 9.86975L12.0718 13.4149L8.53006 9.87311L7.11584 11.2873L12.071 16.2425L12.0718 16.2418Z"
            fill={getIconColor(hasError, disabled, theme)}
          />
        </g>
      </svg>
    </ArrowDownSpan>
  );
};

export default memo(SelectArrowDown);

const ArrowDownSpan = styled.div<{
  $isOpen?: boolean;
}>`
  ${({ theme, $isOpen }: { theme: ITheme; $isOpen?: boolean }) => css`
    pointer-events: none;
    transform: ${$isOpen ? 'rotate(180deg)' : 'none'};
    transition: transform 0.3s ease;
    position: absolute;
    right: ${theme.spacing(1)};
  `}
`;
